/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {BookOfShadowsGameModuleConfig} from "../../BookOfShadowsGameModuleConfig";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {BookOfShadowsGameConfig, IBookOfShadowsWinRatioConfig} from "../../BookOfShadowsGameConfig";

export class WinEnd implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _hasWin: boolean;
    private _tl: TimelineLite;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: ParsedGameData): void {
        this._hasWin = data.singleWin > 0;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedGameData): Timeline | null {
        if (!this._hasWin) {
            return null;
        }
        this._tl = new TimelineLite();

        if (data.isBigWin) {
            this._tl.add([
                BookOfShadowsGameModuleConfig.bigWinView.end(<IBookOfShadowsWinRatioConfig>data.currentWinRatioConfig!, 1, 0.2),
            ], 0);
        }

        this._tl.add(BookOfShadowsGameModuleConfig.countUpView.end(data.singleWin, 1, 0.2, data.isBigWin), 0);

        return this._tl;
    }

    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: ParsedGameData): Timeline | null {
        if (isActive && this._tl && this._tl.timeline) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
        } else {
            if (this._hasWin) {
                this.getAnimation(data);
            }
        }

        BookOfShadowsGameConfig.instance.ABORT_DELAY = (this._tl.totalDuration() - this._tl.time());

        return null;
    }
}